<template>
    <div class="col flex-column d-sm-flex col-widget announcements-widget">
        <page-preloader
            :is-loading="isLoading"
            mode="wrapper"
        >
            <div class="dashboard-widget dashboard-widget--newsletters">
                <div class="d-flex align-items-center justify-content-between gap-1">
                    <div class="d-flex align-items-center gap-0-5">
                        <h4
                            v-text="'Ogłoszenia'"
                            class="dashboard-widget__title mb-0"
                        />
                        <span
                            v-if="announcementsTotal"
                            v-text="announcementsTotal"
                            v-tooltip="$store.getters.getAnnouncementsTotalTooltip"
                            class="a-counter"
                            @click="goToNewAnnouncements"
                        />
                    </div>
                    <the-btn
                        text="Więcej ogłoszeń"
                        class="btn-sm"
                        @click.native="$router.push({ name: 'announcements' })"
                    />
                </div>
                <div v-if="!isLoading" class="dashboard-widget__content">
                    <div class="d-flex flex-column gap-0-5 mt-3">
                        <template v-if="announcements && announcements.length">
                            <announcement-preview
                                v-for="announcement in announcements"
                                size="small"
                                show-more-button
                                show-new-badge
                                :announcement="announcement"
                                :key="announcement.id"
                            />
                        </template>
                        <p
                            v-else
                            v-text="'Brak aktualnych ogłoszeń'"
                            class="mt-2 mb-0"
                        />
                    </div>
                </div>
            </div>
        </page-preloader>
    </div>
</template>

<script>
import AnnouncementPreview from '@/components/announcements/AnnouncementPreview'

export default {
    created() {
        this.fetch()
    },
    components: {
        AnnouncementPreview
    },
    computed: {
        announcements() {
            return this.$store.getters.getAnnouncements
        },
        announcementsTotal() {
            return this.$store.getters.getAnnouncementsTotal
        },
        isLoading() {
            return this.$store.getters.getAnnouncementsStatus === 'loading'
        }
    },
    methods: {
        async fetch() {
            await this.$store.dispatch('clearFilters', 'announcements')
            await this.$store.dispatch('loadAnnouncements', {
                limit: 3,
                offset: 0,
                archival: false,
                sort: {
                    by: 'PUBLICATION_DATE',
                    direction: 'desc'
                }
            })
            this.$store.dispatch('fetchAnnouncementsTotal')
        },
        async goToNewAnnouncements() {
            await this.$store.dispatch('clearFilters', 'announcements')
            await this.$store.dispatch('setFilter', {
                filter: 'read',
                value: true,
                moduleName: 'announcements'
            })
            this.$router.push({ name: 'announcements' })
        }
    }
}
</script>
